<template>
  <div class="not-found">
    <div class="not-found__search">
      <SearchInput
        v-model="searchValue"
        :placeholder="$t('SearchPlaceholder')"
        @search="search"
        @clear="clear"
        class="search-input"
      />
    </div>

    <div class="not-found__title" v-html="$t('SearchTitleError')" />
    <div class="not-found__subtitle">{{ $t("NotFound | Subtitle") }}</div>
    <router-link to="/" class="not-found__button">
      {{ $t("NotFound | GoToMain") }}
    </router-link>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { SearchInput } from "@/shared/ui";
import { ref, onMounted } from "vue";

const router = useRouter();

const searchValue = ref("");

function search() {
  router.push({
    path: "/",
    query: { q: searchValue.value },
  });
}

function clear() {
  searchValue.value = "";
}

onMounted(() => {
  if (router.currentRoute.value?.query?.search) {
    searchValue.value = router.currentRoute.value.query.search;
  }
});
</script>
<style lang="scss" scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__search {
    margin-top: 43px;
    margin-bottom: 120px;
    width: 100%;
  }

  &__title {
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 15px;
    line-height: 115%;
    text-align: center;

    @media (max-width: 575px) {
      font-size: 32px;
    }
  }

  &__subtitle {
    font-size: 16px;
    font-weight: 500;
    color: var(--dark-50);
    margin-bottom: 60px;

    @media (max-width: 575px) {
      margin-bottom: 48px;
      text-align: center;
    }
  }

  &__button {
    padding: 10px 26px;
    background-color: #fafafa;
    color: #111111;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-decoration: none;
  }
}
</style>
